import { LanguageCode } from '@heidi/schema/ml-scribe';

export const nativeDisplayLanguageNames: Readonly<Partial<Record<LanguageCode, string>>> =
  {
    [LanguageCode.en]: 'English',
    [LanguageCode.de]: 'Deutsch',
    [LanguageCode.fr]: 'Français',
    [LanguageCode.es]: 'Español',
    [LanguageCode.it]: 'Italiano',
    [LanguageCode.zh]: '简体中文',
    [LanguageCode.zh_Hant]: '繁體中文',
    [LanguageCode.ja]: '日本語',
    [LanguageCode.ko]: '한국어',
    [LanguageCode.ca]: 'Català',
    [LanguageCode.da]: 'Dansk',
    [LanguageCode.nl]: 'Nederlands',
    [LanguageCode.fi]: 'Suomi',
    [LanguageCode.no]: 'Norsk',
    [LanguageCode.pl]: 'Polski',
    [LanguageCode.pt]: 'Português',
    [LanguageCode.sv]: 'Svenska',
    [LanguageCode.ar_SA]: 'العربية',
    [LanguageCode.ar_AE]: 'العربية',
  } as const;

export const getNativeDisplayLanguageName = (code: LanguageCode): string =>
  nativeDisplayLanguageNames[code] ?? code;
